export const augustUppercase = "nJJ_Ne";
export default {augustUppercase};